import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import type { Database } from "@/types/database.types";

export type ProfileType = Database["public"]["Tables"]["profiles"]["Row"]
export type ProfileTypeWithRole = ProfileType & {
  roles: 
    {
      id: string;
      name: "admin" | "editor" | "viewer"
    }
};

export type CreateUserType = {
  full_name: string;
  email: string;
  password?: string;
  role_id: string;
  email_confirm: boolean;
}

export type Role = {
  id: string;
  name: "admin" | "editor" | "viewer";
};

const supabase = useSupabaseClient();

const adminUsers = async (body: Record<string, any>) => {
  const { data, error } = await supabase.functions.invoke(
    "admin",
    {
      body,
    }
  );

  if (error) {
    console.error(error);
    throw error;
  }

  return data;
};

export const getProfiles = async () => {
  const { data, error } = await supabase
  .from("profiles")
  .select(`
    *,
    roles (
        id,
      name
    )
  `)
  if (error) {
    console.error(error);
      return;
  } 
  return data;
}

export const getRoles = async () => {
    const { data, error } = await supabase
    .from("roles")
    .select(`
          id,
        name
    `)
  
    if (error) {
      console.error(error);
        return;
    } 
    return data;
}

export const updateUser = (
  userId: string,
  data: Partial<ProfileType>
) => {
  return adminUsers({
    action: "update_user",
    userId,
    data,
  });
};

export const createUser = (
  values: CreateUserType
) => {

  return adminUsers({
    action: "create_user",
    email: values.email,
    full_name: values.full_name,
    password: values.password,
    role: values.role_id,
  });
};

export const inviteUser = (
  values: CreateUserType
) => {
  return adminUsers({
    action: "invite_user",
    email: values.email,
    full_name: values.full_name,
    role: values.role_id,
  });
};

export const deleteUser = (userId: string) => {

  return adminUsers({
    action: "delete_user",
    userId,
  });
};

export const forceLogoutUser = (userId: string) => {
  return adminUsers({
    action: "force_logout",
    user_id: userId,
  });
};